import React from 'react';
import { Autocomplete, Box, TextField } from '@mui/material';
import {
  CallStatsFilters,
  Participant,
} from '../../../store/callStats/callStatsTypes';

interface Props {
  /** options populated from the current window's users (real or mock) */
  options: Participant[];
  userId?: string;
  peerUserId?: string;
  onChange: (patch: Partial<CallStatsFilters>) => void;
}

/** Filter by one user, or by a User-A ↔ User-B pair (both selected = pair view). */
const UserPairFilter: React.FC<Props> = ({
  options,
  userId,
  peerUserId,
  onChange,
}) => {
  const byId = (id?: string) => options.find((o) => o.userId === id) ?? null;
  return (
    <Box display="flex" gap={1.5} alignItems="center" flexWrap="wrap">
      <Autocomplete
        size="small"
        sx={{ width: 240 }}
        options={options}
        value={byId(userId)}
        getOptionLabel={(o) => o.displayName}
        isOptionEqualToValue={(o, v) => o.userId === v.userId}
        onChange={(_, v) => onChange({ userId: v?.userId })}
        renderInput={(params) => (
          <TextField {...params} label="User A (filter)" />
        )}
      />
      <Autocomplete
        size="small"
        sx={{ width: 240 }}
        options={options.filter((o) => o.userId !== userId)}
        value={byId(peerUserId)}
        getOptionLabel={(o) => o.displayName}
        isOptionEqualToValue={(o, v) => o.userId === v.userId}
        onChange={(_, v) => onChange({ peerUserId: v?.userId })}
        renderInput={(params) => (
          <TextField {...params} label="User B (pair, optional)" />
        )}
      />
    </Box>
  );
};

export default UserPairFilter;
